









import { Component, Vue } from 'vue-property-decorator';
import Leaflets from '@/components/Leaflets.vue';
import QRCode from '@/components/QRCode.vue';
import Navbar from '@/components/Navbar.vue';
import TweetTimeline from '@/components/TweetTimeline.vue';

@Component({
  components: {
    Leaflets,
    QRCode,
    TweetTimeline,
    Navbar
  }
})
export default class SplitTwitter extends Vue {}
